import { FC } from 'react';
import { useMyTranslations } from '@hooks/useMyTranslations';
import { appLoaderTranslations } from './translations';
import { AppLoaderTransFields, IAppLoaderProps } from './types';

export const AppLoader: FC<IAppLoaderProps> = ({ wrapped = false }) => {
  const { t } = useMyTranslations<AppLoaderTransFields>([appLoaderTranslations.name]);

  return (
    <div className={wrapped ? 'relative w-[100vw] h-[100vh] overflow-hidden justify-center ' : ''}>
      <p>{t('loading')}</p>
    </div>
  );
};
